import { log } from '../app/logger.js';

/**
 * Pictures upload popup.
 */
const PicUploadPopupMixin = MapPopup =>
  class extends MapPopup {
    constructor() {
      super('');
      this.contentEl.classList.add('picupload-mappopup');
    }

    attachPicUploadControl(picUploadControl) {
      this.contentEl.insertBefore(picUploadControl, this.contentEl.firstChild);
      this.#picUploadControl = picUploadControl;
    }

    showFor(marker, noPicSet) {
      log(`[picupload] show pic upload popup for ${marker.id}`);
      if (!noPicSet) {
        this.#picUploadControl.setPic(marker.anchorPicIndex); // async
      }

      if (marker != this.marker) {
        if (this.attached) {
          this.deattach();
        }
        this.position = marker.position;
        this.marker = marker;
      }

      if (!this.attached) {
        this.attachTo(marker.map);
        this.open = true;
      }

      // Let the map popup to draw itself before updating
      // the slider's navbar.
      window.setTimeout(() => {
        this.#picUploadControl.refreshNavBar().then(() => this.#picUploadControl.focus());
      }, 100);
    }

    close() {
      this.deattach();
      this.#picUploadControl.close();
      this.open = false;
    }

    closeIfOpen() {
      if (this.open) {
        this.close();
        return true;
      }
      return false;
    }

    #picUploadControl;
  };

export { PicUploadPopupMixin };
